import { render, staticRenderFns } from "./export-tip.vue?vue&type=template&id=43fca07e"
import script from "./export-tip.vue?vue&type=script&lang=js"
export * from "./export-tip.vue?vue&type=script&lang=js"
import style0 from "./export-tip.vue?vue&type=style&index=0&id=43fca07e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports